<template>
    <div class="all">
        <div class="echart-grid clearfix">
            <div class="row">
                <!-- 数据汇总 -->
                <div class="grid-father">
                    <div class="grid">
                        <div class="grid-header clearfix">
                            <h2 class="title fl">预警来源设置</h2>
                            <div class="fr">
                                <span class="switch" :class="status == 1 ? 'active' : ''" @click="oneButtonSwitch();">预警接收一键开关 <i class="icons switch-icon"></i></span>
                            </div>
                        </div>
                        <div class="grid-header mt20 clearfix">
                            <div class="text-ci fl">
                                <span class="fs40">{{informationNum}}</span><br>
                                <span class="color-8a8a99">关键词预警信息量</span>
                            </div>
                            <!-- <div class="fr">
                                <div class="yujin-text">
                                    <vue-datepicker-local v-model="timeRange" format="YYYY-MM-DD" show-buttons  @confirm="selectedDate"/>
                                </div>
                            </div> -->
                        </div>
                        <div class="grid-body mt15">
                            <div class="set-up">
                                <div class="zi fl">
                                    <a class="a db a1" href="javascript:void(0);" @click="acceptSet();">接收设置</a>
                                </div>
                                <div class="mid zi fl">
                                    <a class="a a3 clearfix" href="javascript:void(0);" @click="yujingSet();">
                                        <i class="icons set-icon"></i>
                                        <span class="db">预警设置</span>
                                    </a>
                                </div>
                                <div class="zi fl">
                                    <a class="a db a2" href="javascript:void(0);" @click="openSet();">关键词设置</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- 预警趋势 -->
                <div class="grid-father">
                    <div class="grid">
                        <div class="grid-header clearfix">
                            <h2 class="title fl">预警趋势</h2>
                            <div class="grid-info fl">
                                <i class="icons icons-question-circle"></i>
                                <p class="grid-tip">分析对象预警信息数量的指数，得分越高，该分析对象相关的预警信息报道数量越多，预警风险越高。</p>
                            </div>
                        </div>
                        <div class="grid-body mt20">
                            <table class="yujin-table" width="100%" border="0" cellpadding="0" cellspacing="0">
                                <colgroup>
                                    <col width="">
                                </colgroup>
                                <thead>
                                    <tr>
                                        <th><span class="text bg-red">红色预警</span></th>
                                        <th><span class="text bg-orange">橙色预警</span></th>
                                        <th><span class="text bg-yelow">黄色预警</span></th>
                                        <th><span class="text bg-gray">灰色预警</span></th>
                                        <th><span class="text bg-green">绿色预警</span></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td><span class="text">POI≥800</span></td>
                                        <td><span class="text">POI≥600</span></td>
                                        <td><span class="text">POI≥300</span></td>
                                        <td><span class="text">POI≥100</span></td>
                                        <td><span class="text">POI&lt;100</span></td>
                                    </tr>
                                </tbody>
                            </table>
                            <div class="echart-warp hidden h259">
                                <barChart id="barEchart" :dataArray="barChartData" barType='warn' barWidth='45%' v-if="barChartData != ''"></barChart>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 预警信息列表 -->
        <div class="grid-father mt20">
            <div class="grid h-auto">
                <div class="grid-header clearfix">
                    <h2 class="title fl">预警信息列表</h2>
                    <div class="fr">
                        <div class="corm ml20 fr clearfix">
                            <span class="element" :class="yuqinType === 0 ? 'curr' : ''" @click="getYujinList(0,0);">关键词预警</span> 
                            <span class="element" :class="yuqinType === 1 ? 'curr' : ''" @click="getYujinList(1,0);">人工预警</span>
                        </div>
                        <span class="zu fr ml20 clearfix">                           
                            <vue-datepicker-local v-model="timeRange" format="YYYY-MM-DD HH:mm:ss" :disabledDate="disabledDate" show-buttons  @confirm="selectedDate"/>
                        </span>
                        <drowDowns class="fr" v-model="collapse" @confirmOption="selectCollapse">
                            <options v-for="(item,index) in collapseList" :key="index" :label="item.label" :value="item.value"></options>
                        </drowDowns>
                    </div>
                </div>
                <div class="grid-body mt20">
                    <div class="firle clearfix">
                        <div class="fl">
                            <label class="checkbox-box tion">
                                <label class="checkbox-warp tion" :class="uuids.length === pageUuid.length  && uuids.length > 0 ? 'curr' : ''">
                                    <input class="checkbox" name="selectAll" @click="checkAll($event)" :checked="uuids.length === pageUuid.length && uuids.length > 0 ? true : false" type="checkbox" value="0">
                                    <i class="icons checkbox-icon"></i>
                                </label>
                                全选
                            </label>
                            <span v-if="yuqinType === 1" class="checkbox-box cp tion" @click="delYujinList();">删除</span>
                            <span class="checkbox-box cp tion" @click="downLoad(1);" title="下载当前所选数据">批量下载</span>
                            <span class="checkbox-box cp tion" @click="downLoad(downType);" title="下载当前方案的所有数据">全部下载</span>
                            <span class="checkbox-box cp tion" @click="isSendYujin();" title="人工发送预警">发送预警</span>
                        </div>
                        <div class="fr">
                            <strong class="color-red fs16">{{totalCount}}</strong> 条
                        </div>
                    </div>
                    <table class="table mt15" width="100%" border="0" cellpadding="0" cellspacing="0">
                        <colgroup>
                            <col width="2%">
                            <col width="40%">
                            <col width="15%">
                            <col width="15%">
                            <col width="15%">
                            <col width="160px">
                        </colgroup>
                        <thead>
                            <tr>
                                <th></th>
                                <th>标题</th>
                                <th><span class="ml20">情感属性</span></th>
                                <th>发布人</th>
                                <th>时间</th>
                                <th>操作</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item,index) in yujinNewsList" :key="index">
                                <td class="td-p0">
                                    <label class="checkbox-warp" :class="uuids.indexOf(item.newsId) != -1 ? 'curr' : ''">
                                        <input class="checkbox" v-model="uuids" name="chooseInfo" type="checkbox" :value="item.newsId">
                                        <i class="icons checkbox-icon"></i>
                                    </label>
                                </td>
                                <td>
									<div class="article-title">
										<router-link class="color-3d3d4c title ovhidden fl" :class="{difference:item.platform === 'comment'}" :title="item.newsTitle" target="_blank" :to="{path:'/detail',query: {data:item.newsId+','+item.newsSimHash+','+startDate+','+endDate}}">{{item.newsTitle}}</router-link>
										<div class="fu fl" v-if="item.platform === 'comment'">
											<span class="color-red fs12">评</span>
										</div>
									</div>
								</td>
                                <td>
                                    <span v-if="item.newsEmotion === '正面'" class="tag ml20 tag-blue">正面</span>
                                    <span v-if="item.newsEmotion === '中性'" class="tag ml20 tag-orange">中性</span>
                                    <span v-if="item.newsEmotion === '负面'" class="tag ml20 tag-red">负面</span>
                                </td>
                                <td>{{item.appName}}</td>
                                <td>{{item.newsPosttime}}</td>
                                <td style="height:50px">
                                    <span class="collect ml-1" @click="collectFn(index);" :class="item.collectStatus === 0 ? '' : 'curr'"><i class="icons collect-icon" style="margin-top:4px;"></i></span>
                                    <span class="sign ml-1 sign-blue cp" @click="oneClickCopy(index)">复</span>
                                    <span class="sign ml-1 sign-red cp" @click="errorCorrection(item.newsId,index);">纠</span>
                                    <span class="sign sign-blue cp ml-1 " @click="newsPathlist(item.newsSimHash)">溯</span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <div class="no-data" v-if="nodata"><span class="text">没有数据哦...</span></div>
                    <!-- 分页 -->
                    <page class="mt20" v-if="totalCount != ''" :currentPage.sync="currentPage" :limit.sync="limit" :totalCount="totalCount" @turn="getTableData"></page>
                </div>
            </div>
        </div>
        <!-- 一键复制 -->
		<copy ref="copy" :text="copyHtml"></copy>
        <!-- 关键词设置 -->
        <Dialog ref="KeywordModal" :callback="keywordSave" width="600" title="关键词设置">
            <div slot="mdBox">
                <div class="keyset">
                    <div>关键词:</div>
                    <textarea class="area mt10" v-model.trim="keywordList" name="" rows="5" cols="" placeholder="请输入您关注的关键词，多个关键词用逗号隔开，最多设置50个关键词" @keyup="keywordWrite();"></textarea>
                </div>
                <div class="keyset">
                    <div>排除词:</div>
                    <textarea class="area mt10" v-model.trim="keywordsExclude" name="" rows="5" cols="" placeholder="请输入排除词，多个排除词用逗号隔开，最多设置50个排除词" @keyup="keywordsExcludeWrite();"></textarea>
                </div>
            </div>
        </Dialog>
        <!-- 预警设置 -->
        <!-- 预警设置 -->
        <Dialog ref="yujingSetModal" :callback="yujingSetSave" width="600" title="预警设置">
            <div slot="mdBox">
                <div class="form-warp name-width0 modal-h420">
                    <h3>自动预警设置</h3>
                    <div class="item mt15 clearfix">
                        <span class="name fl">预警时间:</span>
                        <div class="fl">
                            <span class="drop-down mores">
                                <button class="btn btn-lightblue">{{startHours != 'nulls' ? hours[startHours] : '请选择'}} <i class="icons"></i></button>
                                <ul class="option">
                                    <li v-for="(item,index) in hours" v-if="index != 24" :key="index" @click="selectHours(1,index);">{{item}}</li>
                                </ul>
                            </span>
                            <span class="child">~</span>
                            <span class="drop-down mores">
                                <button class="btn btn-lightblue">{{endHours != 'nulls' ? hours[endHours] : '请选择'}} <i class="icons"></i></button>
                                <ul class="option">
                                    <li v-for="(item,index) in hours" v-if="index != 0" :key="index" @click="selectHours(2,index);">{{item}}</li>
                                </ul>
                            </span>
                        </div>
                        <span class="fs12 color-red fl" style="line-height:32px;padding-left:10px;">*结束时间早于开始时间将自动跨天</span>
                    </div>
                    <div class="item clearfix">
                        <span class="name fl">预警频次:</span>
                        <div class="fl">
                            <span class="drop-down">
                                <button class="btn btn-lightblue">{{frequencySite != 'nulls' ? frequency[frequencySite].name : '请选择'}} <i class="icons"></i></button>
                                <ul class="option">
                                    <li v-for="(item,index) in frequency" @click="selectFrequency(item.value,index);" :key="index">{{item.name}}</li>
                                </ul>
                            </span>
                            <span class="child">/次</span>
                        </div>
                    </div>
                    <div class="item clearfix">
                        <span class="name fl">周末预警:</span>
                        <!-- <div class="input-father">
                            <span class="switch cp db" @click="weekendYujinSwitch();" :class="isWeekend === 0 ? '' : 'active'"><i class="icons switch-icon"></i> 预警</span>
                        </div> -->
                        <div class="input-father checkbox-group">
                            <label class="checkbox-box">
                                <label class="checkbox-warp fl" :class="weeks.indexOf(1) != -1 ? 'curr' : ''"><input name="" v-model.number="weeks" type="checkbox" value="1" class="checkbox"> <i class="icons checkbox-icon"></i></label>
                                <div class="hidden ac">周一</div>
                            </label>
                            <label class="checkbox-box">
                                <label class="checkbox-warp fl" :class="weeks.indexOf(2) != -1 ? 'curr' : ''"><input name="" v-model.number="weeks" type="checkbox" value="2" class="checkbox"> <i class="icons checkbox-icon"></i></label>
                                <div class="hidden ac">周二</div>
                            </label>
                            <label class="checkbox-box">
                                <label class="checkbox-warp fl" :class="weeks.indexOf(3) != -1 ? 'curr' : ''"><input name="" v-model.number="weeks" type="checkbox" value="3" class="checkbox"> <i class="icons checkbox-icon"></i></label>
                                <div class="hidden ac">周三</div>
                            </label>
                            <label class="checkbox-box">
                                <label class="checkbox-warp fl" :class="weeks.indexOf(4) != -1 ? 'curr' : ''"><input name="" v-model.number="weeks" type="checkbox" value="4" class="checkbox"> <i class="icons checkbox-icon"></i></label>
                                <div class="hidden ac">周四</div>
                            </label>
                            <label class="checkbox-box">
                                <label class="checkbox-warp fl" :class="weeks.indexOf(5) != -1 ? 'curr' : ''"><input name="" v-model.number="weeks" type="checkbox" value="5" class="checkbox"> <i class="icons checkbox-icon"></i></label>
                                <div class="hidden ac">周五</div>
                            </label>
                            <label class="checkbox-box">
                                <label class="checkbox-warp fl" :class="weeks.indexOf(6) != -1 ? 'curr' : ''"><input name="" v-model.number="weeks" type="checkbox" value="6" class="checkbox"> <i class="icons checkbox-icon"></i></label>
                                <div class="hidden ac">周六</div>
                            </label>
                            <label class="checkbox-box">
                                <label class="checkbox-warp fl" :class="weeks.indexOf(0) != -1 ? 'curr' : ''"><input name="" v-model.number="weeks" type="checkbox" value="0" class="checkbox"> <i class="icons checkbox-icon"></i></label>
                                <div class="hidden ac">周日</div>
                            </label>
                        </div>
                    </div>
                    <div class="item clearfix">
                        <span class="name fl">情感属性:</span>
                        <div class="input-father checkbox-group">
                            <label class="checkbox-box">
                                <label class="checkbox-warp fl" :class="sentiment.indexOf('正面') != -1 ? 'curr' : ''"><input name="" v-model="sentiment" type="checkbox" value="正面" class="checkbox"> <i class="icons checkbox-icon"></i></label>
                                <div class="hidden ac">正面</div>
                            </label>
                            <label class="checkbox-box">
                                <label class="checkbox-warp fl" :class="sentiment.indexOf('中性') != -1 ? 'curr' : ''"><input name="" v-model="sentiment" type="checkbox" value="中性" class="checkbox"> <i class="icons checkbox-icon"></i></label>
                                <div class="hidden ac">中性</div>
                            </label>
                            <label class="checkbox-box">
                                <label class="checkbox-warp fl" :class="sentiment.indexOf('负面') != -1 ? 'curr' : ''"><input name="" v-model="sentiment" type="checkbox" value="负面" class="checkbox"> <i class="icons checkbox-icon"></i></label>
                                <div class="hidden ac">负面</div>
                            </label>
                        </div>
                    </div>
                    <div class="item clearfix">
                        <span class="name fl">定向信源:</span>
                        <div class="input-father checkbox-group">
                            <label class="checkbox-box">
                                <label class="checkbox-warp fl" :class="{curr:source === '0'}"><input v-model="source" name="xinyuan" type="radio" value="0" class="radio"> <i class="icons radio-icon"></i></label>
                                <div class="hidden ac">全部</div>
                            </label>
                            <label class="checkbox-box">
                                <label class="checkbox-warp fl" :class="{curr:source === '1'}"><input v-model="source" name="xinyuan" type="radio" value="1" class="radio"> <i class="icons radio-icon"></i></label>
                                <div class="hidden ac">重点关注</div>
                            </label>
                        </div>
                    </div>
                    <div class="item clearfix">
                        <span class="name fl">重复信息:</span>
                        <div class="input-father checkbox-group">
                            <label class="checkbox-box" v-for="(item,index) in collapseList" :key="index">
                                <label class="checkbox-warp fl" :class="{curr:setCollapse === item.value}"><input v-model="setCollapse" name="xinyuan" type="radio" :value="item.value" class="radio"> <i class="icons radio-icon"></i></label>
                                <div class="hidden ac">{{item.label}}</div>
                            </label>
                        </div>
                    </div>
                    <div class="item clearfix">
					    <span class="name fl">发送方式:</span>
					    <div class="input-father checkbox-group fl">
					        <label class="checkbox-box">
					            <label class="checkbox-warp fl" :class="{curr:sendType === '1'}"><input v-model="sendType" name="xinyuan" type="radio" value="1" class="radio"> <i class="icons radio-icon"></i></label>
					            <div class="hidden ac">合并发送</div>
					        </label>
					        <label class="checkbox-box">
					            <label class="checkbox-warp fl" :class="{curr:sendType === '2'}"><input v-model="sendType" name="xinyuan" type="radio" value="2" class="radio"> <i class="icons radio-icon"></i></label>
					            <div class="hidden ac">逐条发送</div>
					        </label>
					    </div>
                        <span class="fs12 color-red fl" style="line-height:32px;padding-left:10px;">*此发送方式只针对微信</span>
					</div>
                    <div class="item clearfix">
                        <span class="name fl">媒体类型:</span>
                        <div class="input-father checkbox-group">
                            <label class="checkbox-box" v-for="(item,index) in MediaPlatformList" :key="index">
                                <label class="checkbox-warp fl" :class="platformType.indexOf(index) != -1 ? 'curr' : ''">
                                    <input name="" type="checkbox" class="checkbox" v-model="platformType" :value="item === '全部' ? 'total' : index" /> 
                                    <i class="icons checkbox-icon"></i>
                                </label>
                                <div class="hidden ac">{{item}}</div>
                            </label>
                        </div>
                    </div>
                    <h3 class="mt15">人工预警设置</h3>
                    <div class="item mt15 clearfix">
					    <span class="name fl">发送方式:</span>
					    <div class="input-father checkbox-group self-adaption">
					        <label class="checkbox-box">
					            <label class="checkbox-warp fl" :class="{curr:artificialWarnType == 1}"><input v-model="artificialWarnType" name="xinyuan" type="radio" value="1" class="radio"> <i class="icons radio-icon"></i></label>
					            <div class="hidden ac">发送预警并同步到人工预警列表</div>
					        </label>
					        <label class="checkbox-box">
					            <label class="checkbox-warp fl" :class="{curr:artificialWarnType == 2}"><input v-model="artificialWarnType" name="xinyuan" type="radio" value="2" class="radio"> <i class="icons radio-icon"></i></label>
					            <div class="hidden ac">加入人工预警列表</div>
					        </label>
					    </div>
					</div>
                </div>
            </div>
        </Dialog>
        <!-- 预警接收一键开关 -->
        <Dialog ref="switchModal" :callback="enterSwitch" type="confirm">
            <div slot="mdBox">
                <p>{{status === 0 ? '开启后，将会自动发送预警信息至预警联系人，确认开启？' : '关闭后，预警信息将不会发送给预警联系人处，确认关闭？'}}</p>
                <!-- <p v-if="!openable">预警和关键词尚未设置，设置完才能开启！！！</p> -->
            </div>
        </Dialog>
        <!-- 下载选项 -->
        <Dialog ref="downloadOption" title="下载字段自定义选择" btnText="下载" :callback="enterOption" type="normal" width="600">
            <div slot="mdBox">
                <div class="checkbox-group nolike clearfix">
                    <h4 v-if="downloadTips != ''">tips:<span class="color-red">{{downloadTips}}</span></h4>
                    <label class="checkbox-box">
                        <label class="checkbox-warp fl" :class="selectOptionValue.length === selectOption.length ? 'curr' : ''"><input name="" :checked="selectOptionValue.length === selectOption.length ? true : false" type="checkbox" @click="optionCheckAll($event);" value="" class="checkbox"> <i class="icons checkbox-icon"></i></label>
                        <div class="hidden ac">全选<span class="color-red">（为保证您的下载速度，请尽可能筛选必要的下载字段）</span></div>
                    </label>
                </div>
                <div class="checkbox-group nolike clearfix">
                    <label class="checkbox-box" v-for="(item,index) in selectOption" :key="index">
                        <label class="checkbox-warp fl" :class="selectOptionValue.indexOf(item.type) != -1 ? 'curr' : ''"><input name="" v-model="selectOptionValue" type="checkbox" :value="item.type" class="checkbox"> <i class="icons checkbox-icon"></i></label>
                        <div class="hidden ac">{{item.name}}</div>
                    </label>
                </div>
            </div>
        </Dialog>
        <!-- 删除提示 -->
        <Dialog ref="delModal" :callback="enterDel" type="confirm">
            <div slot="mdBox">
                <p class="ac">是否确认删除?</p>
            </div>
        </Dialog>
        <!-- 预警接收人提示 -->
        <Dialog ref="noPeopleModal" :callback="enterJump" type="confirm" btnText="立即前往">
            <div slot="mdBox">
                <p class="ac">暂无联系人可选择，是否前往<span class="color-blue">添加联系人</span></p>
            </div>
        </Dialog>
        <!-- 发送预警确认提示 -->
        <Dialog ref="sendYujinModal" :callback="sendYujin" type="confirm">
            <div slot="mdBox">
                <p class="ac">是否确认发送预警至已设置的预警联系人？</p>
            </div>
        </Dialog>
        <!-- 情感属性纠错 -->
        <Dialog ref="errorCorrectionModal" :title="$parent.emotionModify === 1 ? '情感属性修改' : '情感属性纠错'" :callback="enterErrorCorrection" btnText="确定" type="normal" width="300">
            <div slot="mdBox">
                <div class="checkbox-group nolike clearfix" v-if="yujinNewsList != ''">
                    <label class="checkbox-box">
                        <label class="checkbox-warp fl" :class="errorAttribute === '正面' ? 'curr' : ''"><input name="attribute" v-model="errorAttribute" type="radio" value="正面" class="radio"> <i class="icons radio-icon"></i></label>
                        <div class="hidden ac">正面</div>
                    </label>
                    <label class="checkbox-box">
                        <label class="checkbox-warp fl" :class="errorAttribute === '中性' ? 'curr' : ''"><input name="attribute" v-model="errorAttribute" type="radio" value="中性" class="radio"> <i class="icons radio-icon"></i></label>
                        <div class="hidden ac">中性</div>
                    </label>
                    <label class="checkbox-box">
                        <label class="checkbox-warp fl" :class="errorAttribute === '负面' ? 'curr' : ''"><input name="attribute" v-model="errorAttribute" type="radio" value="负面" class="radio"> <i class="icons radio-icon"></i></label>
                        <div class="hidden ac">负面</div>
                    </label>
                </div>
            </div>
        </Dialog>
        <!-- 预警接收人设置 -->
        <Dialog ref="peopleModal" :callback="saveContact" type="normal" width="536" title="预警接收设置">
            <div slot="mdBox">
                <vue-scroll :ops="ops" style="width:100%;height:320px">
                    <div class="clearfix">
                        <router-link :to="{path:'/receiveSet'}" class="btn btn-jbblue ml20 fr">添加联系人</router-link>
                        <div class="search-warp hidden clearfix">
                            <button class="search-btn fr"><i class="icons search-icon"></i></button> 
                            <div class="hidden"><input class="input-text" v-model="searchQuery" type="text" placeholder="请输入联系人进行搜索"/></div>
                        </div>
                    </div>
                    <div class="plan-list mt20">
                        <div class="item" v-for="(item,index) in conatctShowList" :key="index" v-if="item.length > 0">
                            <p>
                                <strong v-if="index === 'wx'">微信联系人</strong>
                                <strong v-if="index === 'tel'">短信联系人</strong>
                                <strong v-if="index === 'email'">邮箱联系人</strong>
                            </p>
                            <ul class="people-ul clearfix">
                                <li v-for="(items,indexs) in item"  :key="indexs">
                                    <label class="checkbox-box mt10">
                                        <label class="checkbox-warp fl" :class="selectConatctList.indexOf(items.id) != -1 ? 'curr' : ''">
                                            <input name="" type="checkbox" v-model="selectConatctList" class="checkbox" :value="items.id"> <i class="icons checkbox-icon"></i>
                                        </label> 
                                        <div class="ovhidden al">{{items.username}}</div>
                                    </label>
                                </li>
                            </ul>
                        </div>
                    </div>
                </vue-scroll>
            </div>
        </Dialog>
        <!-- 预警发送提示弹框 -->
        <Dialog ref="sendTipsModal" type="alert">
            <div slot="mdBox">
                <vue-scroll :ops="ops" :style="sendTipsHtml.length > 8 ? 'height:168px' : ''">
                    <p v-for="(item,index) in sendTipsHtml" v-html="item" :key="index"></p>
                </vue-scroll>
            </div>
        </Dialog>
        <!-- 溯源 -->
        <tracingTheSource :postData="postData"></tracingTheSource>
	</div>
</template>
<script>
import {mapState} from 'vuex';
import tracingTheSource from './components/tracingTheSource.vue'
import Dialog from '../../components/dialog.vue';
import VueDatepickerLocal from 'vue-datepicker-local'
import barChart from '../../components/echart/barChart.vue';
import page from '../../components/page.vue';
import copy from '../../components/copy.vue';
export default {
    components:{Dialog,VueDatepickerLocal,barChart,page,copy,tracingTheSource},
    computed:{
        ...mapState({
            platformList: state => state.show.companyinfo.platformList,
        })
    },
    data() {
        const min = '';
        const max = '';
        return {
            planId:'',//方案ID
            timeRange: [min, max],//时间
            hours:[],//小时数组
            frequency:[
                {'name':'实时预警','value':'0.01'},
                {'name':'5分钟','value':'0.05'},
                {'name':'10分钟','value':'0.1'},
                {'name':'20分钟','value':'0.2'},
                {'name':'30分钟','value':'0.3'},
                {'name':'1小时','value':'1'},
                {'name':'2小时','value':'2'},
                {'name':'4小时','value':'4'},
                {'name':'6小时','value':'6'},
                {'name':'8小时','value':'8'},
                {'name':'12小时','value':'12'},
                {'name':'24小时','value':'24'}
            ],//频次
            downloadTips:'',//全部下载提示
			selectOption:[],
            selectOptionValue:['news_title','news_digest','news_author','media_name','news_origin_author_name','media_followers_count','news_url','platform_name','news_emotion','news_content_province','news_posttime','media_province'],//已选择下载
            frequencyValue:'',//频次值
            frequencySite:'nulls',//频次在数组的位置
            initialFrequencySite:'nulls',//初始频次在数组的位置
            yuqinType:0,//舆情预警列表分类
            informationNum:0,//关键词预警信息量
            artificialWarnType:'',//人工预警默认操作
            startDate:'',//预警列表的开始时间
            endDate:'',//预警列表的结束时间
            initialStartHours:'nulls',//初始开始小时
            startHours:'nulls',//开始小时
            initialEndHours:'nulls',//初始结束小时
            endHours:'nulls',//结束小时
            switchs:'',
            timeCheck:'',//预警列表时间开关
            status:'',//预警接受开关状态
            openable:false,//预警开关是否满足条件
            // isWeekend:0,//周末预警开关状态
            initialWeeks:[1,2,3,4,5],//初始星期预警选项
            weeks:[],//星期预警选项
            initialSentiment:['负面'],//初始情感属性
            sentiment:[],//情感属性
            initialSource:'0',//初始信源设置
            source:'',//信源设置
            downType:3,//全部下载时 关键词3 人工4
            downTypes:'',//下载类型
            initialKeywordList:'',//关键词设置
            initialkeywordsExclude:'',//排除词设置
            keywordList:'',//关键词设置
            keywordsExclude:'',//排除词设置
            yujinNewsList:[],//浴巾信息列表
            MediaPlatformList:[],//媒体类型
            initialPlatformType:['total'],//所选媒体类型
            platformType:['total'],//所选媒体类型
            barChartData:[],
            currentPage: 1,//当前页码
            limit: 20,//每页显示条数
            totalCount:0,//总页数
            pageUuid:[],//单分页所有的uuid
            uuids:[],//新闻uuid
            conatctList:[],//联系人列表
            conatctShowList:[],//联系人显示
            initialSelectConatctList:[],//初始已选联系人列表
            selectConatctList:[],//已选联系人列表
            searchQuery:'',//联系人筛选
            sendTipsHtml:'',//发送预警成功提示
			initialSendType:'1',
            sendType:'1',//预警设置发送方式
            errorAttribute:'',//纠错属性的值
            collapseList:[
                {label:'不去重',value:'0'},
                {label:'去重',value:'1'}
            ],//去重不去重
            collapse:'0',
            copyHtml:'',//复制信息
            setCollapse:'',//预警列表设置弹框内的去重参数
            ops: {
                vuescroll: {},
                scrollPanel: {},
                rail: {
                    keepShow:true
                },
                bar: {
                    hoverStyle: true,
                    onlyShowBarOnScroll: false, //是否只有滚动的时候才显示滚动条
                    background: '#c4c4cc',
                }
            },
            nodata:false,//暂无数据
            postData:{}//文章追溯数据
        }
    },
    mounted() {
        let that = this;
		that.$nextTick(()=> {
            that.initialTime();
            that.getAllStatus();
            //that.getMediaPlatform();
            that.makeHours();
            that.getYujinTrend();
            //that.getTableData();
        })
        this.limit=sessionStorage.getItem('limitNum')?Number(sessionStorage.getItem('limitNum')):20;
    },
    created() {
		// 获取缓存方案数据
        this.planId = JSON.parse(sessionStorage.getItem('planStorage')).id;
    },
    methods: {
        //收藏
        collectFn (index) {
            let that = this;
            let yujinNewsList = that.yujinNewsList;
            let sc = yujinNewsList[index].collectStatus;//获取收藏状态
            let url = sc === 0 ? 'user/index/collect' : 'user/index/cancel-collect';
            let uUid = yujinNewsList[index].newsId;
            let data = {
                type:1,
                typeId:[uUid]
            };
            that.$parent.loadModal(true,'正在提交数据');
            that.$api.post(url, {data:data}, r => {
                that.$utils.returnCode(r,function(){
                    that.$parent.showLoad = false;
                    sc = sc === 0 ? 1 : 0;
                    yujinNewsList[index].collectStatus = sc;
                    that.$utils.alertText('操作成功');
                    //that.$store.dispatch('show/changeToast',{text:'操作成功'})
                });
            })
        },
        // 获取当前时间和7天前时间
        initialTime() {
            let max = '';
            let min = '';
            let nowTime = this.$utils.getNowDate();
            let n = nowTime.split(' ');
            let n1 = n[0].split('-');
            let n2 = n[1].split(':');
            let oldTime = this.$utils.getBeforeDay(nowTime,7);
            let o = oldTime.split('-');
            max = new Date(n1[0], n1[1]-1, n1[2], n2[0], n2[1], n2[2])
            min = new Date(o[0], o[1]-1, o[2], n2[0], n2[1], n2[2])
            this.timeRange = [min,max];
            //进页面获取时间数据
            this.startDate = this.$utils.dateConversion(min,1);
            this.endDate = this.$utils.dateConversion(max,1);
        },
        // 获取页面所有状态
        getAllStatus () {
            let that = this;
            that.$parent.loadModal(true,'正在获取数据...');
            that.$api.get('monitor/warning/scheme-warn-info', {sid:that.planId}, r => {
                that.$utils.returnCode(r,function(){
                    let data = r.data;
                    let beginTime = data.beginTime;
                    if(beginTime != ''){
                        beginTime = beginTime.substr(0, 5);
                        let startHours = that.hours.indexOf(beginTime);
                        that.initialStartHours = startHours;
                    }
                    let endTime = data.endTime;
                    if(endTime != ''){
                        endTime = endTime.substr(0, 5);
                        let endHours = that.hours.indexOf(endTime);
                        that.initialEndHours = endHours;
                    }                    
                    if(data.frequency != ''){
                        that.frequencyValue = data.frequency;
                        for(let i in that.frequency){
                            let val = that.frequency[i].value;
                            if(data.frequency === val){
                                that.initialFrequencySite = i;
                            }
                        }
                    }
                    that.artificialWarnType = data.artificialWarnType;//仍预警操作
                    that.initialSelectConatctList = data.contact;//已选联系人
                    if(data.weeks != ''){
                        that.initialWeeks = data.weeks;
                    }
                    that.openable = data.openable;
                    that.initialKeywordList = data.keywords;
                    that.initialkeywordsExclude = data.keywordsExclude;
                    that.collapse = data.collapse.toString();
                    if(data.sentiment != ''){
                        that.initialSentiment = data.sentiment;
                    }
                    if(data.isFocus != ''){
                        that.initialSource = data.isFocus.toString();
                    }
                    if(data.media != ''){
                        that.initialPlatformType = data.media;
                    }
                    that.initialSendType = data.sendType.toString();
                    that.status = data.status;
                    that.getYujinList(0,0);
                });
            })
        },
        // 预警趋势
        getYujinTrend () {
            let that = this;
            that.$api.get('monitor/warning/warn-trend', {sid:that.planId}, r => {
                that.$utils.returnCode(r,function(){
                    let data = r.data;
                    let newData =  {
                        "datetime":data.date,
                        "dataName":['POI'],
                        "data":[
                            data.values
                        ],
                    };
                    that.barChartData = newData;
                });
            })
        },
        // 纠错
        errorCorrection (newsId,index) {
            this.errorCorrectionNewsId  = newsId;
			this.operationIndex = index;
			this.errorAttribute = this.yujinNewsList[index].newsEmotion;
            this.$refs.errorCorrectionModal.showMaskFun();
        },
        // 确认纠错选择
        enterErrorCorrection () {
            let that = this;
            let newsId = that.errorCorrectionNewsId;
			let emotionModify = that.$parent.emotionModify;
			let url = '';
			let text = '';
			if(emotionModify === 1){//修改
				url = 'monitor/info/emotion-revise';
				text = '修改成功';
			}else{//纠错
				url = 'monitor/info/emotion-feedback';
				text = '纠错已提交，谢谢您的反馈';
			}
            if(that.errorAttribute === that.yujinNewsList[that.operationIndex].newsEmotion){
                that.$utils.alertText('选择的情感属性与原本一致');
                return;
            }
            that.$parent.loadModal(true,'正在提交数据');
            that.$api.post(url, {newsId:newsId,emotion:that.errorAttribute}, r => {
                that.$utils.returnCode(r,function(){
					if(emotionModify === 1){//修改后 要改变情感得显示
						that.yujinNewsList[that.operationIndex].newsEmotion = that.errorAttribute;
						that.yujinNewsList[that.operationIndex].emotionRecords = r.data;
					}
                    that.$parent.showLoad = false;
                    that.$utils.alertText(text);
                    //that.$store.dispatch('show/changeToast',{text:text})
                    that.$refs.errorCorrectionModal.closeMask();
                });
            })
        },
        // 获取预警信息列表
        getYujinList (type,pageType) {
            let that = this;
            let url = '';
            if(pageType === 0){//0的时候重置页码
                that.currentPage = 1;
            }
            if(type === 0){//关键词预警
                that.yuqinType = 0;
                that.downType = 3;
                url = 'monitor/warning/warn-list-keyword';
            }else if(type === 1){//人工预警
                that.yuqinType = 1;
                that.downType = 4;
                url = 'monitor/warning/warn-list-artificial';
            }
            that.$parent.loadModal(true,'正在获取数据...');
            that.$api.get(url, {sid:that.planId,page:that.currentPage,collapse:that.collapse,limit:that.limit,startDate:that.startDate,endDate:that.endDate,perpage:that.limit}, r => {
                that.$utils.returnCode(r,function(){
                    that.uuids = [];
                    that.$parent.showLoad = false;
                    let data = r.data;
                    if(data.newsList.length <= 0){//没有数据
                        that.nodata = true;
                    }else{
                         that.nodata = false;
                    }
                    that.totalCount = data.numFound;
                    that.yujinNewsList = data.newsList;
                    if(type === 0){
                        that.informationNum = data.count;
                    }
                    let pageUuid = [];
                    for(let i of data.newsList){
                        pageUuid.push(i.newsId);
                    }
                    that.pageUuid = pageUuid;
                    let copyFields = JSON.parse(sessionStorage.getItem('planStorage')).copyFields;
                    if(that.yujinNewsList.length === 0){
                        return false;
                    }
                    if(copyFields.simNum){
                        that.getSimilarArticle(that.yujinNewsList);
                    }
                });
            })
        },
        // 获取关键词和相似文章
        getSimilarArticle (data) {
            let that = this;
            let oldData = data;
            let simHash = [];
            let newsIds = [];
            let postDate = [];
            for(let i of data){
                simHash.push(i.newsSimHash);
                newsIds.push(i.newsId);
                postDate.push(i.newsPostdate);
            }
            let datas = {
                startDate:that.startDate,
				endDate:that.endDate
            };
            that.$api.post('monitor/info/news-simnum', {simHash:simHash,newsId:newsIds,sid:that.planId,data:datas}, r => {
                that.$utils.returnCode(r,function(){
                    for(let i of data){
                        for(let j in r.data){
                            if(i.newsId === j){
                                i.simNum = r.data[j].simNum;
                            }
                        }
                    }
                });
            })
            that.$api.post('monitor/info/news-keyword', {postDate:postDate,newsId:newsIds}, r => {
                that.$utils.returnCode(r,function(){
                    let datas = r.data;
                    for(let i of data){
                        for(let j in datas){
                            if(i.newsId === j){
                                i.keywords = datas[j].keywords;
                            }
                        }
                    }
                    console.log(data)
                });
            })
        },
        // 全选状态
        checkAll (e) {
            let that = this;
            that.uuids = [];
            let checked = e.target.checked;
            if(checked == true){
                that.uuids = that.pageUuid;//全选的时候 获取所有的uuid
            }else{
                that.uuids = [];
            }
        },
        
        // 发送预警
        isSendYujin () {
            let that = this;
            let people = that.initialSelectConatctList;
            let uuid =  that.uuids;
            if(uuid == ''){
                that.$utils.alertText('请选择需要预警的信息');
                return;
            }else if(people == ''){
                that.$utils.alertText('您还未设置预警接收人');
                return;
            }
            that.$refs.sendYujinModal.showMaskFun();
        },
        sendYujin () {
            let that = this;
            let datas = {
                sid:that.planId,
                newsId:that.uuids
            }
            that.$refs.sendYujinModal.closeMask();
            that.$parent.loadModal(true,'正在提交数据...');
            that.$api.post('monitor/warning/manual-warn', {data:datas}, r => {
                that.$parent.showLoad = false;
                that.$utils.returnCode(r,function(){
                    let status = r.data.status;
                    if(status){
                        that.$refs.sendTipsModal.showMaskFun();
                        that.sendTipsHtml = r.data.msg;
                    }else{
                        that.$utils.alertText(r.data.msg);
                        //that.$store.dispatch('show/changeToast',{text:r.data.msg})
                    }
                });
            })
        },
        // 下载
        downLoad (type) {
            let that = this;
            that.downTypes = type;
            that.selectOptionValue = ['news_title','news_digest','news_author','media_name','news_origin_author_name','media_followers_count','news_url','platform_name','news_emotion','news_content_province','news_posttime','media_province'];
            let uuid = '';//全部下载为空
            if(type === 1){//选择下载
                uuid = that.uuids;
                if(uuid.length <= 0){
                    that.$utils.alertText('请选择需要下载的新闻');
                    return;
                }
            }else{
                if(that.yujinNewsList.length <= 0){
                    that.$utils.alertText('暂无可下载数据');
                    return;
                }
            }
			let datas = {
                uuid:uuid,
                collapse:that.collapse,
			    startDate:that.startDate,
			    endDate:that.endDate,
				isFocus:that.initialSource,
			    field:that.selectOptionValue
			};
			that.$parent.loadModal(true,'正在获取数据...');
			that.$api.post('monitor/info/download-before', {type:type,sid:that.planId,data:datas}, r => {
			    that.$utils.returnCode(r,function(){
			        that.$parent.showLoad = false;
			        that.downloadTips = r.msg;
					that.selectOption = r.data.fieldList;
			        that.$refs.downloadOption.showMaskFun();
			    });
			})
        },
        // 确定下载字段
        enterOption () {
            let that = this;
            if(that.selectOptionValue.length <= 0){
                that.$utils.alertText('请选择需要下载的字段');
                return;
            }
            let uuid = '';//全部下载为空
            let type = that.downTypes;
            if(type === 1){//选择下载
                uuid = that.uuids;
            }
            let datas = {
                uuid:uuid,
                startDate:that.startDate,
                collapse:that.collapse,
                endDate:that.endDate,
				isFocus:that.initialSource,
                field:that.selectOptionValue
            };
            that.$parent.loadModal(true,'正在提交数据...');
            that.$api.post('monitor/info/download', {type:type,sid:that.planId,data:datas}, r => {
                that.$parent.showLoad = false;
                that.$utils.returnCode(r,function(){
                    that.selectOptionValue = [];
                    that.$refs.downloadOption.closeMask();
                    that.$parent.alertTips('已添加到我的下载列表');
                   // that.$store.dispatch('show/changeToast',{text:'已添加到我的下载列表'})
                });
            })
        },
        // 下载字段全选
        optionCheckAll (e) {
            let that = this;
            that.selectOptionValue = [];
            let checked = e.target.checked;
            if(checked == true){
                let selectOption = that.selectOption;
                for(let i of selectOption){
                    that.selectOptionValue.push(i.type);
                }
            }else{
                that.selectOptionValue = [];
            }
            
        },
        // 删除
        delYujinList () {
            let that = this;
            let uuid = that.uuids;
            if(uuid == ''){
                that.$utils.alertText('请选择需要下载的新闻');
                return;
            }
            that.$refs.delModal.showMaskFun();
        },
        // 确认删除
        enterDel () {
            let that = this;
            let datas = {
                newsId:that.uuids,
                sid:that.planId,
                startDate:that.startDate,
                endDate:that.endDate
            };
            that.$parent.loadModal(true,'正在提交数据...');
            that.$refs.delModal.closeMask();
            that.$api.post('monitor/warning/artificial-delete', {data:datas}, r => {
                that.$utils.returnCode(r,function(){
                    that.$parent.showLoad = false;
                    that.getYujinList(1,0);
                    that.$utils.alertText('删除成功');
                    //that.$store.dispatch('show/changeToast',{text:'删除成功'})
                });
            })
        },
        // 获取媒体类型
        // getMediaPlatform () {
        //     let that = this;
        //     that.platformType = [];
        //     that.$parent.loadModal(true,'正在获取数据...');
        //     that.$api.get('monitor/analysis/platform', null, r => {
        //         that.$utils.returnCode(r,function(){
        //             that.$parent.showLoad = false;
        //             let data = r.data;
        //             that.MediaPlatformList = data;
        //         });
        //     })
        // },
        // 小时数组生成
        makeHours () {
            let that = this;
            let hours = [];
            for(let i = 0;i < 25;i++){
                i = i < 10 ? '0'+i+'' : i;
                hours.push(''+i+':00');
            }
            that.hours = hours;
        },
        // 选择小时
        selectHours (type,index) {
            let that = this;
            if(type === 1){//开始时间
                // if(index >= that.endHours && that.endHours != 'nulls'){
                //     return;
                // }
                that.startHours = index;
            }else if(type === 2){//结束时间
                // if(index <= that.startHours && that.startHours != 'nulls'){
                //     return;
                // }
                that.endHours = index;
            }
        },
        // 选择频次
        selectFrequency (value,index) {
            this.frequencyValue = value;
            this.frequencySite = index;
        },
        // 预警一键开关
        oneButtonSwitch () {
            let that = this;
            // if(!that.openable){
            //     that.$parent.alertTips('请先进行预警和关键词设置!!!');
            // }else{
                
            // }
            that.$refs.switchModal.showMaskFun();
        },
        // 确认预警开关
        enterSwitch () {
            let that = this;
            let status = that.status;
            let val = '';
            if(status === 0){
                val = 1;
            }else{
                val = 0;
            }
            let datas = {
                sid:that.planId,
                status:val
            }
            that.$parent.loadModal(true,'正在提交数据...');
            that.$api.post('monitor/warning/switch', {data:datas}, r => {
                that.$utils.returnCode(r,function(){
                    that.$parent.showLoad = false;
                    let data = r.data;
                    that.status = data.status;
                    that.$refs.switchModal.closeMask();
                    that.$utils.alertText('设置成功');
                    //that.$store.dispatch('show/changeToast',{text:'设置成功'})
                });
            })
        },
        // 选择去重方式
        selectCollapse (){
            this.getYujinList(this.yuqinType,0);
        },
        // 时间选择
        selectedDate () {
            let that = this;
            that.startDate = that.$utils.dateConversion(that.timeRange[0],1);
            that.endDate = that.$utils.dateConversion(that.timeRange[1],1);
            let day = that.$utils.getDateDiff(that.startDate,that.endDate);
            if(day > that.$parent.timeSection){
                that.$utils.alertText('时间跨度最大限制'+that.$parent.timeSection+'天','',1500);
                return;
            }
            that.getYujinList(that.yuqinType,0);
        },
        disabledDate(time){
            let day = this.$parent.timeSection;//获取当前用户的时间范围权限
            let nowTime = this.$utils.getNowDate();//今天时间
            let startDate = this.$utils.getBeforeDay(nowTime,day);//根据时间权限获取最早时间
            let n = nowTime.split(' ');
            startDate = startDate + ' ' + n[1]
            let number = this.$utils.dateToMillisecond(startDate);//将获取的最早时间转化成毫秒
            if(time.getTime() > new Date().getTime() || time.getTime() < number) return true;
        },
        // 关键词设置
        openSet () {
            // let that = this;
            // that.$api.post('monitor/warning/switch', {data:datas}, r => {
            //     that.$parent.returnCode(r,function(){
            //         let data = r.data;
            //         that.status = data.status;
            //         that.$refs.switchModal.closeMask();
            //         that.$utils.alertText('设置成功');
            //     });
            // })
            this.$refs.KeywordModal.showMaskFun();
            this.keywordList = this.initialKeywordList;
            this.keywordsExclude = this.initialkeywordsExclude;
        },
        // 关键词输入控制
        keywordWrite () {
            let that = this;
            let keywordList = that.keywordList;
            let keywordList1 = '';
            //中文逗号转英文
            keywordList1 = keywordList.replace(/，/g,",");
            that.keywordList = keywordList1;
            // 获取第一个字符
            let frist = that.keywordList[0] 
            //去除连续,
            let pattern = /\,{2}/;//去除连续正则
            let len = (keywordList.match(/,/g)||[]).length;
            if(len >= 50 || pattern.test(that.keywordList) || frist === ','){//判断分析词个数和连续,
                keywordList1 = keywordList.substr(0, keywordList.length - 1); 
                that.keywordList = keywordList1;
            }
        },
        keywordsExcludeWrite () {
            let that = this;
            let keywordsExclude = that.keywordsExclude;
            let keywordsExclude1 = '';
            //中文逗号转英文
            keywordsExclude1 = keywordsExclude.replace(/，/g,",");
            that.keywordsExclude = keywordsExclude1;
            // 获取第一个字符
            let frist = that.keywordsExclude[0] 
            //去除连续,
            let pattern = /\,{2}/;//去除连续正则
            let len = (keywordsExclude.match(/,/g)||[]).length;
            if(len >= 50 || pattern.test(that.keywordsExclude) || frist === ','){//判断分析词个数和连续,
                keywordsExclude1 = keywordsExclude.substr(0, keywordsExclude.length - 1); 
                that.keywordsExclude = keywordsExclude1;
            }
        },
        // 关键词设置保存
        keywordSave () {
            let that = this;
            let keywordList = that.keywordList;
            for(let i of keywordList.split(',')){
                if(i.length > 10){
                    that.$utils.alertText('每个关键词最多10个字符');
                    return;
                }
            }
            if(keywordList.split(',').length>50){
                that.$utils.alertText('最多设置50个关键词');
                return;
            }
            let keywordsExclude = that.keywordsExclude;
            for(let i of keywordsExclude.split(',')){
                if(i.length > 10){
                    that.$utils.alertText('每个排除词最多10个字符');
                    return;
                }
            }
            if(keywordsExclude.split(',').length>50){
                that.$utils.alertText('最多设置50个排除词');
                return;
            }
            // if(keywordList == ''){
            //     that.$utils.alertText('关键词不能为空');
            //     return;
            // }
            let datas = {
                sid:that.planId,keywords:keywordList,keywordsExclude:keywordsExclude
            }
            that.$parent.loadModal(true,'正在提交数据...');
            that.$api.post('monitor/warning/keywords', {data:datas}, r => {
                that.$utils.returnCode(r,function(){
                    let data = r.data;
                    that.$utils.alertText(r.msg);
                    that.$refs.KeywordModal.closeMask();
                    let yuqinType = that.yuqinType;
                    if(yuqinType === 0){
                        that.getYujinList(0,0);
                    }else{
                        that.getYujinList(1,0);
                    }
                    that.getYujinTrend();
                    that.initialKeywordList = that.keywordList;
                    that.initialkeywordsExclude = that.keywordsExclude;
                    that.openable = data.openable;
                    that.$utils.alertText('关键词设置成功');
                    //that.$store.dispatch('show/changeToast',{text:'关键词设置成功'})
                });
            })
        },
        // 接收设置
        acceptSet () {
            let that = this;
            that.selectConatctList = that.initialSelectConatctList;
            that.$parent.loadModal(true,'正在获取数据...');
            that.$api.get('user/contact/list', null, r => {
                that.$utils.returnCode(r,function(){
                    that.$parent.showLoad = false;
                    if(r.data['wx'].length <= 0 && r.data['email'].length <= 0 && r.data['tel'].length <= 0){//没有联系人
                        that.$refs.noPeopleModal.showMaskFun();
                        return;
                    }
                    that.conatctList = r.data;
                    that.conatctShowList = r.data;
                    that.$refs.peopleModal.showMaskFun(); 
                });
            })
        },
        // 跳转联系人
        enterJump () {
            this.$router.push({ path:'/receiveSet'});
        },
        // 保存联系人
        saveContact () {
            let that = this;
            that.$parent.loadModal(true,'正在提交数据...');
            let datas = {
                sid:that.planId,
                contact:that.selectConatctList
            }
            that.$api.post('monitor/warning-user/add-warn-contact', {data:datas}, r => {
                that.$parent.showLoad = false;
                that.$utils.returnCode(r,function(){
                    that.$refs.peopleModal.closeMask();
                    that.initialSelectConatctList = that.selectConatctList;
                    that.$utils.alertText('设置成功'); 
                    //that.$store.dispatch('show/changeToast',{text:'设置成功'})
                });
            })
        },
        // 搜索联系人
        searchPlan (val) {
            let that = this;
            if(val == ''){
                that.conatctShowList = that.conatctList;
            }else{
                let conatctList = that.conatctList;
                let schemeList = {};
                for(let i in conatctList){
                    let num = 0;
                    let arr = [];
                    for(let j of conatctList[i]){
                        let name = j.username;
                        if(name.indexOf(val) != -1){
                            arr.push(j)
                        }
                    }
                    if(arr != ''){
                        // console.log(arr);
                        schemeList[i]=arr;
                    }
                }
                that.conatctShowList = schemeList;
            }
        },
        // 预警设置
        yujingSet () {
            let that = this;
            that.startHours = that.initialStartHours;
            that.endHours = that.initialEndHours;
            that.frequencySite = that.initialFrequencySite;
            that.weeks = that.initialWeeks;
            that.sentiment = that.initialSentiment;
            that.source = that.initialSource;
            that.sendType = that.initialSendType;
            that.setCollapse = that.collapse;
            that.platformType = that.initialPlatformType;
            that.$refs.yujingSetModal.showMaskFun();
        },
        // 预警设置保存
        yujingSetSave () {
            let that = this;
            let startHours = that.startHours;
            let endHours = that.endHours;
            let frequencyValue = that.frequencyValue;
            let weeks = that.weeks;
            let sentiment = that.sentiment;
            // 预警时间校验
            if(startHours == 'nulls' || endHours == 'nulls'){
                that.$utils.alertText('请选择预警时间');
                return;
            }
            // 预警频次校验
            if(frequencyValue == ''){
                that.$utils.alertText('请选择预警频次');
                return;
            }
            // 星期校验
            if(weeks.length == 0){
                that.$utils.alertText('请选择星期属性');
                return;
            }
            // 情感属性校验
            if(sentiment.length == 0){
                that.$utils.alertText('请选择情感属性');
                return;
            }
            // 媒体类型校验
            if(that.platformType.length == 0){
                that.$utils.alertText('请选择媒体类型');
                return;
            }
            let beginTime = that.hours[startHours] + ':00';
            let endTime = that.hours[endHours] + ':00';
            let datas = {
                sid:that.planId,
                beginTime:beginTime,
                endTime:endTime,
                artificialWarnType:that.artificialWarnType,
                frequency:that.frequencyValue,
                weeks:that.weeks,
                collapse:that.setCollapse,
				sendType:that.sendType,
                media:that.platformType,
                isFocus:that.source,
                sentiment:that.sentiment
            }
            that.$parent.loadModal(true,'正在提交数据...');
            that.$api.post('monitor/warning/info-set', {data:datas}, r => {
                that.$utils.returnCode(r,function(){
                    that.$parent.showLoad = false;
                    let data = r.data;
                    that.initialStartHours = that.startHours;
                    that.initialEndHours = that.endHours;
                    that.initialFrequencySite = that.frequencySite;
                    that.initialSentiment = that.sentiment;
                    that.initialSource = that.source;
                    that.initialWeeks = that.weeks;
                    that.initialPlatformType = that.platformType;
                    that.initialSendType = that.sendType;
                    that.collapse = that.setCollapse;
                    that.openable = data.openable;
                    that.$utils.alertText('设置成功');
                    if(that.artificialWarnType == 1){
                        that.$store.dispatch('show/yujinType',{text:'设置成功'})
                    }else{
                        that.$store.dispatch('show/yujinType',{text:'添加人工预警成功'})
                    }
                    that.$refs.yujingSetModal.closeMask();
                    let yuqinType = that.yuqinType;
                    if(yuqinType === 0){
                        that.getYujinList(0,0);
                    }else{ 
                        that.getYujinList(1,0);
                    }
                    that.getYujinTrend();
                });
                //that.$store.dispatch('show/changeToast',{text:'预警设置成功'})
            })
        },
        // 周末预警开关
        weekendYujinSwitch () {
            let isWeekend = this.isWeekend;
            if(isWeekend === 0){
                this.isWeekend = 1;
            }else{
                this.isWeekend = 0;
            }
        },
        getTableData() {
            this.getYujinList(this.yuqinType);
        },
        // 一键复制
		oneClickCopy (index){
			let that = this;
            let list = that.yujinNewsList[index];
            this.copyHtml = '';
            let copyFields = JSON.parse(sessionStorage.getItem('planStorage')).copyFields;
            for(let i in copyFields){
                if(list[i] === undefined){
                    this.copyHtml += copyFields[i]+':'+'暂无\n'
                }else{
                    this.copyHtml += copyFields[i]+':'+list[i]+'\n'
                }
            }
            //that.$store.dispatch('show/changeToast',{text:'复制成功'})
        },
        // 文章追溯
        newsPathlist (simHash){
            this.postData = {
                simHash:simHash,
                sid:this.planId
            }
        }
	},
    watch: {
        platformType(){
            let that = this;
            let len = that.platformType.length;
            if(that.platformType[0] === 'total' && len > 1){//选择非全部 
                that.platformType.splice(0,1);
            }else if(that.platformType[len-1] === 'total' && len > 1){
                that.platformType = ['total'];
            } 
        },
        weeks () {
            // console.log(this.weeks);
        },
        searchQuery (val) {
            this.searchPlan(val);    
        },
        platformList:{
            handler(){
                let map_ = new Map();
                for(let item of this.platformList){
                    map_.set(item.type,item.name)
                }
                let obj= Object.create(null);
                for (let[k,v] of map_) {
                    obj[k] = v;
                }
                this.MediaPlatformList = obj;
                console.log(obj)
            },immediate:true
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/page/yuqingFenxi/yuJinCenter.vue